<div class="container">
    <div class="row clearfix">
        <div class="col-md-12 column">
   <div style="text-align: center;"> <h2>信息系统用户注册</h2> </div>
<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" style="margin-top: 40px;">
    <div class="form-group">
        <label for="nickName">你的昵称</label>
        <input type="text" formControlName="nickName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.nickName.errors }" />
        <div *ngIf="submitted && f.nickName.errors" class="invalid-feedback">
            <div *ngIf="f.nickName.errors.required">请输入你的昵称</div>
        </div>
    </div>
    <div class="form-group">
        <label for="username">登录用户名</label>
        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required">请输入登录用户名</div>
        </div>
    </div>
    <div class="form-group">
        <label for="userEmail">用户邮箱</label>
        <input type="text" formControlName="userEmail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.userEmail.errors }" />
        <div *ngIf="submitted && f.userEmail.errors" class="invalid-feedback">
            <div *ngIf="f.userEmail.errors.required">请邮箱地址</div>
            <div *ngIf="f.userEmail.errors.email">请正确的邮箱格式</div>
        </div>
    </div>
    <div class="form-group">
        <label for="password">登录密码</label>
        <input type="text" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">请输入密码</div>
            <div *ngIf="f.password.errors.minlength">密码长度最少是6位</div>
        </div>
    </div>
    <div class="form-group">
        <label for="password2">再输入一次密码</label>
        <input type="text" formControlName="password2" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password2.errors }" />
        <div *ngIf="submitted && f.password2.errors" class="invalid-feedback">
            <div *ngIf="f.password2.errors.required">请再次输入确认密码</div>
            <div *ngIf="f.password2.errors.minlength">密码长度最少是6位</div>
            <div *ngIf="f.password2.errors.confirmPasswordValidator">两次输入的密码不相同</div>
        </div>
    </div>
    <div class="form-group">
        <label for="varifyCode">输入验证码</label>
        <input type="text" formControlName="varifyCode" id="varifyCode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.varifyCode.errors }" />
        <div id="v_container" (click)="refresh()" style="margin-top:10px;margin-bottom: 10px;">
            <canvas id="verifyCanvas" width="100" height="40" style="cursor: pointer;"></canvas>
            <a (click)="refresh()" style="margin-left: 5px;cursor: pointer;">看不清？</a>
        </div>
        <div *ngIf="submitted && f.varifyCode.errors" class="invalid-feedback">
            <div *ngIf="f.varifyCode.errors.required">请输入验证码</div>
            <div *ngIf="f.varifyCode.errors.notSame">验证码不正确</div>
        </div>
    </div>

    <div class="form-group">
        <button [disabled]="loading" class="btn btn-primary">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            提交
        </button>
        <a routerLink="/login" class="btn btn-link">取消</a>
    </div>
</form>
</div>
</div>
</div>